import { reqF } from "./axiosFun";

export const GetExportHistoryPageList = (params) => {
	return reqF("post", "/api/sysConfig/Common/GetExportHistoryPageList", params);
};

//导出日志分页列表（按导出人/导出时间范围/描述查询）
export const GetExportLogPageList = (params) => {
	return reqF("post", "/api/sysConfig/Common/GetExportLogPageList", params);
};
